module.exports = __webpack_public_path__ + "img/award-trophy-big.474ad718.svg";